import { render, staticRenderFns } from "./NftCustomConfirmRemove.vue?vue&type=template&id=bf5fb564&scoped=true&lang=html&"
import script from "./NftCustomConfirmRemove.vue?vue&type=script&lang=js&"
export * from "./NftCustomConfirmRemove.vue?vue&type=script&lang=js&"
import style0 from "./NftCustomConfirmRemove.vue?vue&type=style&index=0&id=bf5fb564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5fb564",
  null
  
)

export default component.exports